module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Menu_Sidebar', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					menu: {
						widget: 'Widget',
						autoRender: true,
						template: 'menu_sidebar',
						embed: {
							widget: '@parent @parent',
							container: 'nav.navigation#navigation'
						}
					}
				},

				handleWom: {
					highlight: {
						widget: '@this',
						event: 'pageChanged',
						callback: '_handlePageChange'
					}
				}
				
			})

			this.callParent('configure', arguments);
		},

		running: function () {
			this.menu = this.wom1('#menu');
			this.layout = this.wom1('@parent @parent @parent');

			this.callParent('running', arguments);
		},

		_handlePageChange: function (pageData) {
			if (this.menu._indom) {
				this.highlight(pageData.page);

				return;
			}

			this.handleEvent(this.menu, 'addedToDom', fox.bind(function () {
				this.highlight(pageData.page);
			}, this), {once: true, prefix: 'sectionMenu'});
		},

		highlight: function (page) {
			fox.each(this.menu.dom('[href]'), function (link) {
				fox.dom.removeClass('active', link.parentNode);
			}, this)

			fox.dom.addClass('active', this.menu.dom1('[href="/' + page + '"]').parentNode);
		}

	}, 'Menu2');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/menu/sidebar.js
// module id = 129
// module chunks = 0